import React, { useEffect } from "react"; 
import { HiOutlineViewList } from 'react-icons/hi'; 
import { GiBurningDot } from 'react-icons/gi'; 
import { SiSitepoint } from 'react-icons/si'; 
import { GoPrimitiveDot } from 'react-icons/go'; 
import './style.css'; 


let Home=(props)=> { 
  
  useEffect(()=>{ document.body.style.backgroundColor = `#fff`; 
  console.log(">>>>>>>>>>"); 
}) 
  
  
  
  return(
  <div>{/* navigation bar */}
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div className="mainNAvig">
      <div className="texting">
        <h1>
  When Your Digital Investment must produce result 
      </h1>
        <h5>
         Financial Garing & Product Formulation solution for digital investment
     </h5>
        <div id='subhead'>
          <GiBurningDot id='iconRig' color='#FFCD24' size={25}/>
          <p id="mainPara">Pick the right idea</p>
        </div>
        <div id='subhead'>
          <GiBurningDot id='iconRig' color='#FFCD24' size={25}/>
          <p id="mainPara">Build The Right Product</p>
        </div>
        <div id='subhead'>
          <GiBurningDot id='iconRig' color='#FFCD24' size={25}/>
          <p id="mainPara">Go laughing to the bank - Pure Joy!!</p>
        </div>
        <div id='subhead'>
          <GiBurningDot id='iconRig' color='#FFCD24' size={25}/>
          <p id="mainPara" style={{width: '85%'}}>3 decades of digital expereince poured into tangible scorecards for avoiding losses and designing success</p>
        </div>
      </div>
      <img className="imgSlide" src="https://www.kindpng.com/picc/m/356-3567002_work-office-clipart-clipart-collection-office-work-icons.png"></img>
    </div>
    <div className="boxnotwo">
      <div className="mainHes">
        <h1>
      Know the outcome Beforehand
  </h1>
        <p>
        The Takeoff Point is a financial gating solution for your digital investments.
It creates accurate foresight into future of any proposed digital investment

and helps you make the right choices. It also helps you in formulating the

right products. The Takeoff Point is comprehensive, accurate and one of it kind framework,
that is easy to use and provides accurate Go / No-Go decisions for your

digital investments rapidly. It puts you several years ahead in your game. </p>
      </div>
      <div className="mainHes2">
        <div className="Merow">
          <div className="Merow">
            <SiSitepoint id='iconSize' color='#FFCD24' size={25}/>
            <h4 id='padd4'>1.
  </h4>
          </div>
          <div>
            <h4>
       Opportunity Score</h4>
            <p>Know if the problem you are trying to solve is worth it?
Wiillit generate revenue, when and how much?

Do you have the right product rationale?

Eliminate seeds of failures, know your risk and

fight the right battle</p>
          </div>
        </div>
        <div className="Merow">
          <div className="Merow">
            <SiSitepoint id='iconSize' color='#FFCD24' size={25}/>
            <h4 id='padd4'>2.
  </h4>
          </div>
          <div>
            <h4>
      Execution Score</h4>
            <p>Know if you can execute on the opportunity based
on your unique sitation, your resources, teams and
expertise. A comprehensive evaluation, pin points areas
of improvement for rapid and succeful execution
</p>
          </div>
        </div>
        <div className="Merow">
          <div className="Merow">
            <SiSitepoint id='iconSize' color='#FFCD24' size={25}/>
            <h4 id='padd4'>3.
  </h4>
          </div>
          <div>
            <h4>
       Product Formulation</h4>
            <p>Know what exactly you need to build to please the
customers and defeat the competition. Know how to pivot
your product to turn around stuck initiatives. Land
undefetable products</p>
          </div>
        </div>
      </div>
    </div>
    <div className="section13">
      <h3>
      Can't Wait? Get Going Right Now
  </h3>
      <div className="section3">
        <div className="cardME">
          <h3>
      if you like to read
  </h3>
          <p> Read The book ,master the art. <p></p>  Start Online Evalution </p>
       
          <img src={require( '../asset/look.png')} className="mainImage"></img>
        </div>
        <div className="cardME">
          <h3>
      You are a video person
  </h3>
          <p>Watch video ,master the art. <p></p> Start Online Evalution</p>
          <img src="http://assets.stickpng.com/images/580b57fcd9996e24bc43c545.png" className="mainImage"></img>
        </div>
        <div className="cardME">
          <h3>
      You are human on hand on learn as you go person
  </h3>
          <p>Start Online Evalution <p></p> Master The Art along the Way</p>
          <img src="https://www.seekpng.com/png/full/264-2640487_go-png-hd-angry-birds-go-pig-rock.png" className="mainImage"></img>
        </div>
      </div>
    </div>
    <div className="section13">
      <h3>
  You Want Everything handle for you?</h3>
      <div className="section3">
        <div className="cardME2">
          <h4>
Consulting  </h4>
          <p>Easy engagment <p></p>
Quick turn around<p></p>
Expertise from the founder</p>
        </div>
        <div className="cardME2">
          <h4>
      Reach And Marketing
  </h4>
          <p>
          Build or validate your research
<p></p>
Evaluate and execute your digital marketing
          </p>
        </div>
        <div className="cardME2">
          <h4>
    Corporate Traning
  </h4>
          <p>
          Infuse culture of digital prudence
<p></p>
Customized training program for rapid adoption
          </p>
        </div>
      </div>
    </div>
    <div class="jumbotron jumbotron-fluid saving">
      <div class="container">
        <h4 class="display-6" id="jumbh4">What Counstomer Are saying?</h4>
        <p class="lead" style={{color: '#404654',fontWeight: '700',fontSize:14,marginTop:20}}>Overall this a great book if you are looking for a comprehensive playbook
that addresses right gating touchpoints, frameworks and formal scorecards to bring your innovation to market.

Innovation is a tricky space, one has to be optimistic and yet have a healthy detachment from their idea(in author's words "dispassionate attitude").

</p>
        <p class="lead" id='jumbp'>Gates of go-nogo decisions are many and makes innovative product launches tricky.
Without a structured framework unbridled optimism leads to millions of wasted dollars, countless hours of wasted effort.</p>
        <p class="lead" id='jumbp'> This book addresses the how part very effect

 

|lam responsible for envisioning and formulating digital solutions and plan to use this book as my go to from now on. If you are in a position to make mission critical digital invest.</p>
      </div>
    </div>
    <div className="boxnotwo">
      <div className="mainHes">
        <h1>
      Takeoff Point Work Across all industories
  </h1>
        <p style={{fontWeight:700}}>It's for
Corporate leaders,
Executives,
Venture capitialist,
Angle investors,
Product Manager,
Product Owners,
Entreprenuers
</p>
      </div>
      <div className="mainHes2" style={{paddingLeft: '7%'}}>
        <h3>
    High Value Benifit
  </h3>
        <h5 id="h5home">
  <GoPrimitiveDot id='iconSize' color='#FFCD24' size={20}/>
      1. Avoid loss of capital</h5>
        <h5 id="h5home">
  <GoPrimitiveDot id='iconSize' color='#FFCD24' size={20}/>
      2. Avoid loss of time</h5>
        <h5 id="h5home">
  <GoPrimitiveDot id='iconSize' color='#FFCD24' size={20}/>
      3. Avoid loss of reputation</h5>
        <h5 id="h5home">
  <GoPrimitiveDot id='iconSize' color='#FFCD24' size={20}/>
      4. Build right product at right time</h5>
        <h5 id="h5home">
  <GoPrimitiveDot id='iconSize' color='#FFCD24' size={20}/>
      5. Unleash massive growth and revenue</h5>
        <h5 id="h5home">
  <GoPrimitiveDot id='iconSize' color='#FFCD24' size={20}/>
      6. Turn existing products into game changers</h5>
        <h5 id="h5home">
  <GoPrimitiveDot id='iconSize' color='#FFCD24' size={20}/>
      7. Build high impact roadmap</h5>
        <h5 id="h5home">
  <GoPrimitiveDot id='iconSize' color='#FFCD24' size={20}/>
      8. with accurate priorities</h5>
       <h5 id="h5home">
  <GoPrimitiveDot id='iconSize' color='#FFCD24' size={20}/>
      9. Avoid all bad things that comes
with failures</h5>
        <h5 id="h5home">
  <GoPrimitiveDot id='iconSize' color='#FFCD24' size={20}/>
      10. Reap all benefits that comes with
Success</h5>
      </div>
    </div>
    <div class="jumbotron" id="jumbotron2" >
      <h1 class="display-6" id='jumbph6'>Take a Test Drive!</h1>
      <p class="lead" id='jumb2p'>Run a known successful or failed digital initiative through the framework and see the results</p>
      
      <p class="lead"> <a class="btn btn-primary btn-lg" href="#" role="button" style={{backgroundColor: '#050E2F',border: 'none',outline: 'none'}}>Start Here Free</a>
      </p>
      <p id='jumb2p'>For passionate digital leaders, there is no bigger joy than
being right about a digital investment and see it produce results

When your decisions have large consequences use
The Takeoff Point - Start here</p>
    </div>
  </div>) }
   export default Home;